/* Small-pair presentation and opt-in custom event hooks. Cart logic remains the existing verified planner. */
(() => {
  function emit(root, action) {
    try {
      const s = window.Shopify;
      if (!s?.customerPrivacy?.analyticsProcessingAllowed?.() || !s?.analytics?.publish) return;
      const selected = [...root.querySelectorAll('[data-fridge-item]')].filter(c => c.querySelector('[data-planner-check]')?.checked);
      const result = s.analytics.publish('storageoz:pair_pilot', {test_id:root.dataset.pairPilot, action,
        products:selected.map(c => ({variant_id:c.querySelector('[data-planner-variant]')?.value, quantity:Number(c.querySelector('[data-planner-quantity]')?.value || 0)}))});
      if(result?.catch) result.catch(() => {});
    } catch (_) { /* Analytics is optional and must not block shopping. */ }
  }
  function init(root) {
    if(root.dataset.pairPresentationReady) return;
    root.dataset.pairPresentationReady = 'true';
    function images(){
      root.querySelectorAll('[data-fridge-item]').forEach(card => {
        const option=card.querySelector('[data-planner-variant]')?.selectedOptions[0];
        const img=card.querySelector('.soz-ft-product-photo img');
        if(option?.dataset.imageUrl && img){img.removeAttribute('srcset');img.src=option.dataset.imageUrl;}
      });
    }
    root.addEventListener('change', () => {images();emit(root,'selection_changed');});
    root.querySelectorAll('[data-planner-add]').forEach(b => b.addEventListener('click',() => {if(!b.disabled) emit(root,'add_attempt');},true));
    let seen=false;
    const observe=()=>{if(!seen){seen=true;emit(root,'view');}};
    if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observe();observer.disconnect();}},{threshold:.15});observer.observe(root);}else observe();
    document.addEventListener('visitorConsentCollected',()=>{if(seen) emit(root,'view_after_consent');});
    images();
  }
  function start(){document.querySelectorAll('[data-pair-pilot]').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();
